<template>
  <v-card flat>
    <v-card-text>
      <!-- Summary Cards -->
      <v-row v-if="report" class="mb-4">
        <v-col cols="6" sm="4">
          <v-card color="blue darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.overall_avg_days }} days
            </div>
            <div class="caption">Overall Avg Turnaround</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4">
          <v-card color="green darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.total_completed }}
            </div>
            <div class="caption">Total Completed</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4">
          <v-card color="orange darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.total_in_progress }}
            </div>
            <div class="caption">Still In Progress</div>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="report">
        <!-- Completed Units Table -->
        <h3 class="subtitle-1 font-weight-bold mb-2 mt-4">
          <v-icon left small color="green">mdi-check-circle</v-icon>
          Completed Units
        </h3>
        <v-data-table
          v-if="report.completed && report.completed.length > 0"
          :items="report.completed"
          :headers="completedHeaders"
          dense
          :items-per-page="25"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, -1] }"
        >
          <template v-slot:item.avg_days="{ item }">
            <v-chip :color="getTurnaroundColor(item.avg_days)" dark small>
              {{ item.avg_days }}
            </v-chip>
          </template>
        </v-data-table>
        <div v-else class="text-center pa-4 grey--text">
          No completed units found for this period.
        </div>

        <!-- In Progress Units Table -->
        <h3 class="subtitle-1 font-weight-bold mb-2 mt-6">
          <v-icon left small color="orange">mdi-clock-outline</v-icon>
          In Progress
        </h3>
        <v-data-table
          v-if="report.in_progress && report.in_progress.length > 0"
          :items="report.in_progress"
          :headers="inProgressHeaders"
          dense
          :items-per-page="25"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, -1] }"
        >
          <template v-slot:item.avg_days_waiting="{ item }">
            <v-chip
              :color="getTurnaroundColor(item.avg_days_waiting)"
              dark
              small
            >
              {{ item.avg_days_waiting }} days
            </v-chip>
          </template>
        </v-data-table>
        <div v-else class="text-center pa-4 grey--text">
          No units currently in progress for this period.
        </div>
      </template>

      <!-- Empty State -->
      <div v-if="!report" class="text-center grey--text pa-10">
        <v-icon size="64" color="grey lighten-1">mdi-timer-sand</v-icon>
        <p class="mt-4 subtitle-1">
          Click "Generate" to see service turnaround times.
        </p>
        <p class="caption grey--text">
          Uses the date range from the filters above. Default: last 30 days.
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ServiceTurnaroundTime",
  props: {
    filters: { type: Object, required: true },
  },
  data() {
    return {
      report: null,
      completedHeaders: [
        { text: "Unit Type", value: "unit_type" },
        { text: "Total Units", value: "total_units", align: "center" },
        { text: "Avg Days", value: "avg_days", align: "center" },
        { text: "Min Days", value: "min_days", align: "center" },
        { text: "Max Days", value: "max_days", align: "center" },
        { text: "Same Day", value: "same_day", align: "center" },
        { text: "1-3 Days", value: "days_1_3", align: "center" },
        { text: "4-7 Days", value: "days_4_7", align: "center" },
        { text: "7+ Days", value: "days_7_plus", align: "center" },
      ],
      inProgressHeaders: [
        { text: "Unit Type", value: "unit_type" },
        { text: "Units Waiting", value: "units_waiting", align: "center" },
        {
          text: "Avg Days Waiting",
          value: "avg_days_waiting",
          align: "center",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      fetchReport: "service_reports/get_turnaround_time_report",
    }),
    getTurnaroundColor(days) {
      if (days <= 1) return "green";
      if (days <= 3) return "teal";
      if (days <= 7) return "orange";
      return "red";
    },
    async generate() {
      try {
        let params = {};
        if (this.filters.from_date) params.from_date = this.filters.from_date;
        if (this.filters.to_date) params.to_date = this.filters.to_date;
        if (this.filters.branch_id) params.branch_id = this.filters.branch_id;
        let data = await this.fetchReport(params);
        this.report = data;
      } catch (e) {
        this.$alert({
          title: "Error",
          message:
            "Error generating turnaround time report: " +
            (e.response?.data?.error || e.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
  },
};
</script>
